import styles from './Head.module.css';
import {
useResolvedPath,
Link,
useMatch
} from 'react-router-dom'


import React, { Component } from 'react'

export default class Head extends Component {
    render() {
        return (
            <div className={styles.Head}>
            <div>
                CameronCunning.com
            </div>
            <nav>
                <CustomLink to="/">Latest</CustomLink>
                <CustomLink to="/binomial">Binomial Theorem</CustomLink>
                {/* <CustomLink>Older</CustomLink> */}
            </nav>    
            </div>
        )
    }
}


function CustomLink({children, to, ...props}) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
    return (
        <>
        <Link 
        className={styles.link}
        style={{ textDecoration: match ? "underline" : "none" }}
        to={to}>
        {children}
        </Link>
        </>
    )
}
